module.exports = __webpack_public_path__ + "h5/img/medal03.8ea8d2a6.png";